export const environment = {
  production: true,
  host: import.meta.env.NG_APP_BACKEND_URL,
  host_tiktok: import.meta.env.NG_APP_BACKEND_URL_TIKTOK,
  authHost: import.meta.env.NG_APP_AUTH_URL,
  videoHost: import.meta.env.NG_APP_VIDEO_URL,
  amplitudeApiKey: import.meta.env.NG_APP_AMPLITUDE_API_KEY,
  intercomAppId: import.meta.env.NG_APP_INTERCOM_APP_ID,
  toolName: import.meta.env.NG_APP_TOOL_NAME,
  branchName: import.meta.env.NG_APP_CI_COMMIT_REF_NAME,
  sentry_dsn: import.meta.env.NG_APP_SENTRY_DSN,
  aitarget_domain: import.meta.env.NG_APP_AITARGET_DOMAIN,
  aitarget_subdomain: import.meta.env.NG_APP_AITARGET_SUBDOMAIN,
  google_recaptcha_site_key: import.meta.env.NG_APP_GOOGLE_RECAPTCHA_SITE_KEY,
  youtubeTutorVideoRu: import.meta.env.NG_APP_YOUTUBE_TUTOR_VIDEO_RU,
  youtubeTutorVideoEn: import.meta.env.NG_APP_YOUTUBE_TUTOR_VIDEO_EN,
  gtmId: import.meta.env.NG_APP_GTM_ID,
  sentry_enabled: true,
  sentry_environment: 'production',
  sentry_release: import.meta.env.NG_APP_SENTRY_RELEASE,
  facebookPixelId: import.meta.env.NG_APP_FACEBOOK_PIXEL_ID,
  ipGeoLocationKey: import.meta.env.NG_APP_IP_GEO_LOCATION_KEY,
  callTouchCounterId: import.meta.env.NG_APP_CALL_TOUCH_COUNTER_ID,
  redirectEnabled: import.meta.env.NG_APP_REDIRECT_ENABLED.toLowerCase() === 'true',
  redirectUrl: import.meta.env.NG_APP_REDIRECT_URL,
  yandexMetrikaId: import.meta.env.NG_APP_YANDEX_METRIKA_ID
};
